import React, { useState, useEffect, useContext } from 'react';
import { translate, setLanguage, getLanguage } from 'react-multi-lang';
import { Menu, Select, Row, Col } from 'antd';
import {
  ApartmentOutlined,
  ContactsOutlined,
  FundProjectionScreenOutlined,
  HomeOutlined,
  PoweroffOutlined,
  SettingOutlined,
  SkinOutlined,
  TeamOutlined,
  UserOutlined,
  MobileOutlined,
} from '@ant-design/icons';

import { MenuTriatContext } from "../context/menu-triat";

const { SubMenu } = Menu;

function MenuLateral(props) {
  const [menuTriat, setMenuTriat] = useContext(MenuTriatContext);
  const [openKeys, setOpenKeys] = useState(['Dashboard']);

  // submenu keys of first level
  const rootSubmenuKeys = ['Dashboard', 'Pares_Configuracio'];

  useEffect(() => {
    if(menuTriat==='Dashboard'){
      setOpenKeys(['Dashboard']);
      document.getElementById("Dashboard").classList.add("ant-menu-item-selected");
      //Array.from(document.getElementsByClassName('MenuLateral ant-menu-submenu-open ant-menu-submenu-selected')).forEach((el) => el.classList.remove('ant-menu-submenu-selected'));
      //Array.from(document.getElementsByClassName('MenuLateral ant-menu-submenu-open')).forEach((el) => el.classList.remove('ant-menu-submenu-open'));
      Array.from(document.getElementsByClassName('ant-menu-item-only-child ant-menu-item-selected')).forEach((el) => el.classList.remove('ant-menu-item-selected'));
    }else{
      document.getElementById("Dashboard").classList.remove("ant-menu-item-selected");
    }
  },[menuTriat]);


  const changeLang = (lang) =>{
      setLanguage(lang);
      sessionStorage.setItem('Language',lang);
    }

    const onOpenChange = openKeys_list => {
      //console.log('openKeys', openKeys);
      //console.log('openKeys_list', openKeys_list);
      const latestOpenKey = openKeys_list.find(key => openKeys.indexOf(key) === -1);
      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        setOpenKeys(openKeys_list);
      } else {
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);

      }
    };
    const triarMenu = (menuTriat) =>{
      //setPerfilUsuari(perfilUsuari => ({...perfilUsuari, menuTriat: key}));
      setMenuTriat(menuTriat);
    }


    return (
      <Menu
        theme="light"
        className="MenuLateral"
        mode="inline"
        onClick={({key}) => triarMenu(key)}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{ width: '100%', height: '100%' }}
        defaultSelectedKeys="Dashboard"
      >
        <Menu.Item key="Dashboard" className="MenuLateral" id="Dashboard">
          <span>
            <HomeOutlined />
            <span>{props.t('menu.inicio')}</span>
          </span>
        </Menu.Item>


          {/*<div style={{paddingLeft:'48px'}}>*/}
          <div style={{paddingLeft:'24px'}}>
            <span>{props.t('generic.idioma')}:&nbsp;&nbsp;</span>
            <Select defaultValue={getLanguage()} onChange={changeLang} style={{ width: 110}} size="small">
              <Select.Option value="es">Castellano</Select.Option>
              <Select.Option value="ca">Català</Select.Option>
              <Select.Option value="en">English</Select.Option>
              {/*idiomes*/}
            </Select>
          </div>

      {/*  </SubMenu>*/}
        <Menu.Item key="Logout" className="MenuLateral">
          <span>
            <PoweroffOutlined />
            <span>{props.t('menu.cerrar_sesion')}</span>
          </span>
        </Menu.Item>
      </Menu>
    );
}

export default translate(MenuLateral);
